<template>
  <section v-if="me" id="section__kyc" class="view-container">
    <div class="width-100">
      <p class="font--p-3 mt-5 mb-10">인증 받은 신분증을 제출해주세요</p>
      <div class="documents-items">
        <v-file-input
          prepend-icon=""
          outlined
          append-icon="mdi-plus-circle-outline"
          placeholder="신분증"
          >신분증
        </v-file-input>
      </div>
      <BasicButton :to="{ path: '/apply/complete' }">파일 제출 완료</BasicButton>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('auth', ['me']),
  },
  async created() {},
}
</script>

<style lang="scss" scoped>
#kyc {
}
</style>
